import {
    IAtendimentoCliente,
    IAtendimentoClienteRequest,
    IListarAtendimentoClienteResponse,
    TModoGestaoAtendimento,
} from "../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import {
    ListarAtendimentosClienteService,
    ListarAtendimentosParaTransferirService,
} from "../../../Services/AtendimentoCliente/GestaoDeClientes/GestaoDeAtendimentoServices";

import { ValidationErr } from "../../../Validations/ValidationError";
import { Controller } from "../../Controller";

export async function ListarAtendimentosClienteController(
    data: IAtendimentoClienteRequest,
    pagina: number,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento,
    excel?: boolean
) {
    const response =
        await ListarAtendimentosClienteService<IListarAtendimentoClienteResponse>(
            data,
            pagina,
            SEG_ATENDIMENTOS,
            excel
        )
            .then((response) => {
                return {
                    ATENDIMENTOS: response.data.ATENDIMENTOCLIENTE?.map(
                        (atendimento) => {
                            return {
                                ...atendimento,
                                Atendimento: {
                                    DS_CATEGORIA_ATENDIMENTO:
                                        atendimento.DS_CATEGORIA_ATENDIMENTO,
                                    DS_SUBCATEGORIA:
                                        atendimento.DS_SUBCATEGORIA,
                                    DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                                        atendimento.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
                                    ID_CATEGORIA_ATENDIMENTO:
                                        atendimento.ID_CATEGORIA_ATENDIMENTO,
                                    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                                        atendimento.ID_CATEGORIA_ATENDIMENTO,
                                    ID_CASO_HISTORICO:
                                        atendimento.HISTORICO.ID_CASO_HISTORICO,
                                    NR_DIAS_ATRASO: atendimento.NR_DIAS_ATRASO,
                                    NR_DIAS_ATRASO_SLO:
                                        atendimento.NR_DIAS_ATRASO_SLO,
                                    ID_USUARIO: atendimento.ID_USUARIO,
                                    ID_USUARIO_ACOMPANHAMENTO:
                                        atendimento.ID_ACOMPANHAMENTO,
                                    DS_MOTIVO_CANCELAMENTO:
                                        atendimento.DS_MOTIVO_CANCELAMENTO,
                                },
                                DS_ATENDENTE: atendimento.DS_NOME_USUARIO,
                                DS_CANAL_ATENDIMENTO:
                                    atendimento.DS_TIPO_CANAL_ATENDIMENTO,
                                DS_ULTIMO_HISTORICO:
                                    atendimento.HISTORICO.DS_ULTIMO_HISTORICO,
                                QTD_HISTORICOS:
                                    atendimento.HISTORICO.QTD_HISTORICOS,
                                DS_CASO: atendimento.DS_CASO,
                                DT_FIM: atendimento.DT_FIM,
                                DT_INICIO: atendimento.DT_INICIO,
                                DS_STATUS_CASO: atendimento.DS_STATUS_CASO,
                                ID_CASO: atendimento.ID_CASO,
                                CONTA: {
                                    DS_CONTATO:
                                        atendimento.CONTATO.DS_NOME_CONTATO,
                                    DS_EMAIL: [],
                                    DS_NOME: atendimento.CONTA.DS_NOME_CLIENTE,
                                    ID_CONTATO: atendimento.CONTATO.ID_CONTATO,
                                    NR_TELEFONE:
                                        atendimento.CONTATO.TELEFONES_CONTATOS,
                                    NR_CPF: atendimento.CONTA.NR_CPF,
                                },
                                PRODUTO: {
                                    DS_EMPREENDIMENTO:
                                        atendimento.PRODUTO.DS_PRODUTO,
                                    ID_EMPREENDIMENTO:
                                        atendimento.PRODUTO.ID_PRODUTO,
                                    UNIDADE: {
                                        DS_UNIDADE:
                                            atendimento.UNIDADE.DS_UNIDADE,
                                        ID_UNIDADE:
                                            atendimento.UNIDADE.ID_UNIDADE,
                                    },
                                },
                            } as IAtendimentoCliente;
                        }
                    ),
                    PAGINAS: response.data.PAGINAS,
                    NR_CASOS: response.data.NR_CASOS,
                    NR_CASOS_EM_ATRASO: response.data.NR_CASOS_EM_ATRASO,
                    NR_CASOS_EM_DIA: response.data.NR_CASOS_EM_DIA,
                };
            })
            .catch((err) => {
                ValidationErr(err);
                throw err;
            });

    return response;
}

export async function ListarAtendimentosParaTransferirController(
    data: IAtendimentoClienteRequest,
    pagina: number,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento
) {
    return Controller(
        ListarAtendimentosParaTransferirService(data, pagina, SEG_ATENDIMENTOS)
    );
}

export async function ExportarExcelAtendimentosClienteController(
    data: IAtendimentoClienteRequest,
    pagina: number,
    SEG_ATENDIMENTOS: TModoGestaoAtendimento
) {
    return Controller(
        ListarAtendimentosClienteService<Blob>(
            data,
            pagina,
            SEG_ATENDIMENTOS,
            true
        )
    );
}
